import './location-announcement.scss'

import { Icon } from '@vista-digital/occ-ui'
import { useState } from 'react'
import { setSessionStorage, getSessionStorage } from '../../utilities/sessionStorage'
import { RichTextExtension } from '../../feComponents'
import { observer } from 'mobx-react'
import { locationService } from '../../services'
import React from 'react'

const sessionKey = 'location-announcement-override'

export const LocationAnnouncementComponent: React.FC = observer(() => {
    const [isLocationAnnouncementVisible, setIsLocationAnnouncementVisible] = useState(true)

    const overrideLocationAnnouncement = (): void => {
        setSessionStorage<boolean>(sessionKey, true)
        setIsLocationAnnouncementVisible(false)
    }

    const data = locationService.getLocationAnnouncement()

    if (!data) return null

    const { startDateTime, endDateTime, heading, message, daysOfWeek } = data
    const show: boolean =
        showLocationAnnouncement(startDateTime, endDateTime, daysOfWeek) && isLocationAnnouncementVisible

    return (
        <>
            {show && (
                <div className="location-announcement">
                    <div className="container-lg-padding no-bottom-spacing">
                        <div className="location-announcement__content">
                            {heading && <strong className="location-announcement__heading">{heading}</strong>}
                            <RichTextExtension htmlText={message} />
                            <div className="close-button" onClick={overrideLocationAnnouncement}>
                                <Icon name="cross" />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
})

const showLocationAnnouncement = (startDateTime: Date, endDateTime: Date, daysOfWeek: string[]): boolean => {
    const now = new Date()
    const localTimeZoneStartDateTime = new Date(startDateTime)
    const localTimeZoneEndDateTime = new Date(endDateTime)

    const weekday = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    const currentDay = weekday[now.getDay()]

    let validDayOfWeek = daysOfWeek?.some(d => d === currentDay) ?? false

    const validDate: boolean = now > localTimeZoneStartDateTime && now < localTimeZoneEndDateTime

    const hasUserOverride = (): boolean => {
        return getSessionStorage<boolean>(sessionKey) ? true : false
    }

    return validDayOfWeek && validDate && !hasUserOverride()
}

export default LocationAnnouncementComponent
